import { doc, collection } from 'firebase/firestore';
import { db } from '@/firebase/config';

/**
 * Generates a Firestore-compatible unique ID
 * @returns A Firestore-style document ID
 */
export function generateId(): string {
  const ref = doc(collection(db, '_unused'));
  return ref.id;
} 